import { Spaces } from "../../../assets/Variables/SpaceVariables.js";
import * as TextVariables from "../../../assets/Variables/TextVariables.js";
import Colors from "../../../assets/Variables/ColorsVariables.js";
import { useBreakpoint } from "../../../config/BreakpointContext.js";
import { BackHand, Height, HouseSidingSharp, Margin, Padding } from "@mui/icons-material";
import Background from "../../Backgrounds/Background.js";

export const useDynamicStyles = () => {
  const { issXs, isXs, isMd } = useBreakpoint();

  return {
    settingsRisckCoreHead: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      justifyContent: "flex-start",
      height: issXs ? "100%" : "401px",
      padding: "0"
    },
    settingsRisckCoreChild: {
      display: "flex",
      height: "100%",
    },
    settingsValueCenter: {
      padding: "0px 0px 0px 0px",
      position: "absolute",
      top: "55%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      textAlign: "center",
      gap: "20",
      width: "100%",

    },
    settingsRisckCore: {
      display: "flex",
      flexDirection: issXs ? "column" : "row",
      justifyContent: "center",
      gap: "10px"
    },
    settingsValuesBox: {
      display: "flex",
      flexDirection: issXs ? "column" : "row",
      gap: issXs ? Spaces.Size_2 : Spaces.Size_1,
      padding: "10px 0 40px 0", 
  
    },
    strategySettingsLabels: {
      display: "flex",
      flexDirection: "row",
      gap: Spaces.Size_1,
      alignItems: "center",
      justifyContent: "center",
    },
    valueSettingTitle: {
      fontFamily: TextVariables.Caption_1,
      lineHeight: "1.4",
      color: Colors.Secondary_700,
    },

    labelDateTitle: {
      fontFamily: TextVariables.Overline,
      lineHeight: "1",
      color: Colors.Secondary_700,
    },

    separatorPoint: {
      fontFamily: TextVariables.Caption_2_Bold,
      lineHeight: "1.4",
      color: Colors.Secondary_400,
      display: "flex",
      alignItems: "center",
    },
    comboBoxChartJS: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      gap: "10px",

    }, comboBoxChartJSmb: {
        display: "flex",
        flexDirection: "column",   // primero apila verticalmente
        alignItems: "flex-start",  // 👈 alinea a la izquierda
        justifyContent: "flex-start",
        gap: "10px",
    },
     comboChild: {
        display: "flex",
        flexDirection: "row",   // primero apila verticalmente
        gap: "20px",
    },comboChildmb: {
        display: "flex",
        flexDirection: "column",   // primero apila verticalmente
        alignItems: "stretch",   // 👈 alinea a la izquierda
        gap: "20px",
        width: "100%",
    },quoteChartJS: {
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center",
      marginLeft: "0%"
    },



  }

};
